import type { Rule } from 'antd/es/form';

const SPOTIFY_ARTIST_ID_PATTERN = /^[a-zA-Z0-9]{22}$/;
const SPOTIFY_ARTIST_URL_PATTERN =
    /(open\.spotify\.com\/(?:intl-[^/]+\/)?artist\/|artists\.spotify\.com\/c\/artist\/|spotify:artist:)/i;

export const validateSpotifyArtistIdOrUrl = async (value?: string) => {
    const trimmed = value?.trim();
    if (!trimmed) {
        return;
    }
    if (SPOTIFY_ARTIST_ID_PATTERN.test(trimmed) || SPOTIFY_ARTIST_URL_PATTERN.test(trimmed)) {
        return;
    }
    throw new Error('Enter a 22-character Spotify artist ID or a valid Spotify artist URL');
};

export const spotifyArtistIdRules: Rule[] = [
    {
        validator: async (_, value) => validateSpotifyArtistIdOrUrl(value),
    },
];
